/**
 * Deque Accessibility Efficiency Calculator JavaScript
 */
(function ($) {
  "use strict";

  // Calculator state
  let currentCalculationData = null;
  let accessibleModal = null;
  let calculatorForm = null;
  let dataToLeadForm = null;

  /**
   * Initialize calculator when DOM is ready
   */
  $(document).ready(function () {
    initializeCalculator();
  });

  /**
   * Initialize all calculator functionality
   */
  function initializeCalculator() {
    // Initialize accessibility components first
    initializeAccessibilityComponents();

    // Initialize accessible tooltips
    initializeTooltips();

    // Currency toggle functionality
    initializeCurrencyToggle();

    // Form submission handler
    $("#efficiency-calculator-form").on("submit", handleCalculatorSubmission);

    // Modal functionality
    initializeModal();

    // Input change handlers for real-time updates
    setupInputHandlers();
  }

  /**
   * Initialize accessibility components
   */
  function initializeAccessibilityComponents() {
    try {
      // Initialize accessible modal if class is available
      if (typeof DQAccessibleModal !== "undefined") {
        accessibleModal = new DQAccessibleModal({
          debug: false, // Set to true for development
        });
        // Make accessible modal available globally for other components
        window.accessibleModal = accessibleModal;
      }

      // Initialize accessible forms if class is available
      if (typeof DQAccessibleForm !== "undefined") {
        // Calculator form
        calculatorForm = new DQAccessibleForm({
          formId: "efficiency-calculator-form",
          enableErrorNavigation: true,
          announceValidation: true,
          focusErrorsOnSubmit: true,
          debug: false,
        });
      }
    } catch (error) {
      console.warn("Accessibility components initialization error:", error);
    }
  }

  /**
   * Initialize currency toggle functionality
   */
  function initializeCurrencyToggle() {
    $(".currency-btn").on("click", function (e) {
      e.preventDefault();

      const currency = $(this).data("currency");
      const currencyConfig = dq_aec_ajax.currencies[currency];

      // Update active state and ARIA attributes
      $(".currency-btn").removeClass("active").attr("aria-selected", "false");
      $(this).addClass("active").attr("aria-selected", "true");

      // Update hidden input
      $("#currency").val(currency);

      // Update currency symbol in form
      $(".currency-symbol").text(currencyConfig.symbol);

      // If we have calculation data, recalculate with new currency
      if (currentCalculationData && $("#calculator-results").is(":visible")) {
        const $form = $("#efficiency-calculator-form");
        setTimeout(function () {
          $form.trigger("submit");
        }, 100);
      }
    });
  }

  /**
   * Initialize accessible tooltips ("toggletips").
   *
   * The help text is injected into a polite live region on activation so
   * screen readers announce it. It stays open until dismissed with Escape, a
   * second activation, an outside click, or by moving focus elsewhere.
   */
  function initializeTooltips() {
    const closeAll = ({ except } = {}) => {
      $(".tooltip.is-open").not(except).removeClass("is-open").find(".tooltip-text").empty();
    };

    $(".tooltip-trigger").on("click", function () {
      const $tooltip = $(this).closest(".tooltip");
      const wasOpen = $tooltip.hasClass("is-open");

      closeAll();
      if (wasOpen) {
        return;
      }

      // Clear first, then populate, so repeat activations are re-announced.
      const $content = $tooltip.find(".tooltip-text").empty();
      setTimeout(() => {
        $content.text($tooltip.data("tooltip-text"));
        $tooltip.addClass("is-open");
      }, 100);
    });

    // Dismiss on Escape (returning focus to the trigger), outside click, or focus leaving.
    $(document).on("keydown", (e) => {
      if (e.key !== "Escape") {
        return;
      }
      const $open = $(".tooltip.is-open");
      if ($open.length) {
        $open.find(".tooltip-trigger").trigger("focus");
        closeAll();
      }
    });

    $(document).on("click", (e) => {
      if (!$(e.target).closest(".tooltip").length) {
        closeAll();
      }
    });

    $(document).on("focusin", (e) => {
      closeAll({ except: $(e.target).closest(".tooltip") });
    });
  }

  /**
   * Handle calculator form submission
   */

  function fetchNonce() {
    return $.get(dq_aec_ajax.ajax_url, { action: "dq_get_nonce" });
  }

  function handleCalculatorSubmission(e) {
    e.preventDefault();

    const $form = $(this);
    const $submitButton = $form.find(".calculate-btn");

    clearErrors();

    if (!validateForm($form)) return;

    const formData = getFormData($form);
    formData.action = "calculate_efficiency";

    $submitButton.addClass("loading").prop("disabled", true);

    fetchNonce().done(function (nonceResponse) {
      if (!nonceResponse.success) {
        showError("Security error. Please reload the page.");
        return;
      }

      formData.nonce = nonceResponse.data.nonce;

      $.ajax({
        url: dq_aec_ajax.ajax_url,
        type: "POST",
        data: formData,
        success: function (response) {
          if (response.success) {
            currentCalculationData = response.data;
            showResults(response.data);
            dataToLeadForm = { ...response.data };
          } else {
            showError(response.data.message || "Calculation failed. Please try again.");
          }
        },
        error: function () {
          showError("There was a problem processing your request.");
        },
        complete: function () {
          $submitButton.removeClass("loading").prop("disabled", false);
          window.dataToLeadForm = dataToLeadForm;
        }
      });

    });
  }


  /**
   * Get form data as object
   */
  function getFormData($form) {
    const data = {};

    $form.find("input, select, textarea").each(function () {
      const $input = $(this);
      const name = $input.attr("name");
      const value = $input.val();

      if (name && value !== "") {
        data[name] = value;
      }
    });

    return data;
  }

  /**
   * Validate form inputs
   */
  function validateForm($form) {
    let isValid = true;
    const errors = [];

    // Check required fields
    $form.find("input[required]").each(function () {
      const $input = $(this);
      const value = parseFloat($input.val());
      const fieldName = $input.attr("name").replace("_", " ");

      if (!value || value <= 0) {
        isValid = false;
        $input.addClass("error");
        errors.push(fieldName + " must be greater than 0");
      } else {
        $input.removeClass("error");
      }
    });

    if (!isValid) {
      showError("Please correct the following errors:<br>• " + errors.join("<br>• "));
    }

    return isValid;
  }

  /**
   * Show calculation results
   */
  function showResults(data) {
    // Populate results
    $("#current-annual-cost").text(data.current.annual_cost);
    $("#current-hours-year").text(data.current.hours_per_year);

    $("#deque-annual-cost").text(data.with_deque.annual_cost);
    $("#deque-issues-year").text(data.with_deque.issues_per_year);
    $("#deque-hours-year").text(data.with_deque.hours_per_year);

    $("#annual-savings-money").text(data.savings.annual_savings);
    $("#annual-savings-time").text(data.savings.hours_saved);

    // Add percentage savings if element exists
    if ($("#percentage-savings").length) {
      $("#percentage-savings").text(data.savings.percentage_savings);
    }

    // Show results section
    $("#calculator-results").slideDown(500);

    // Scroll to results
    $("html, body").animate(
      {
        scrollTop: $("#calculator-results").offset().top - 50,
      },
      500
    );
  }

  /**
   * Initialize modal functionality
   */
  function initializeModal() {
    // If accessible modal is not available, use fallback implementation
    if (!accessibleModal) {
      // Fallback modal implementation
      $("#request-estimate-btn").on("click", function () {
        openModalFallback();
      });

      // Close modal
      $("#modal-close, #cancel-btn").on("click", function () {
        closeModal();
      });

      // Close on overlay click
      $("#lead-form-modal").on("click", function (e) {
        if (e.target === this) {
          closeModal();
        }
      });

      // Close on escape key
      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && $("#lead-form-modal").is(":visible")) {
          closeModal();
        }
      });
    }
    // If accessible modal is available, it handles everything automatically
  }

  /**
   * Fallback modal opening for when accessibility components aren't available
   */
  function openModalFallback() {
    const modal = $("#lead-form-modal");

    // Basic accessibility setup
    modal.attr("aria-hidden", "false");
    modal.fadeIn(300);

    // Focus first input for basic accessibility
    setTimeout(function () {
      const firstInput = modal.find("input:first-of-type").first();
      if (firstInput.length) {
        firstInput.focus();
      }
    }, 350);

    // Prevent body scroll (don't use aria-hidden on body)
    $("body").css("overflow", "hidden");
  }

  /**
   * Close modal
   */
  function closeModal() {
    if (accessibleModal) {
      // Use accessible modal's close method
      accessibleModal.close();
    } else {
      // Fallback close implementation
      const modal = $("#lead-form-modal");
      modal.attr("aria-hidden", "true");
      modal.fadeOut(300);

      // Restore body scroll
      $("body").css("overflow", "");
    }
  }

  /**
   * Setup input handlers for enhanced UX
   */
  function setupInputHandlers() {
    // Remove error class on input change
    $(document).on("input change", "input.error", function () {
      $(this).removeClass("error");
    });

    // Format number inputs
    $(document).on("blur", 'input[type="number"]', function () {
      const $input = $(this);
      const value = parseFloat($input.val());

      if (!isNaN(value) && value > 0) {
        // Format with appropriate decimal places
        const step = parseFloat($input.attr("step")) || 1;
        const decimals = step < 1 ? 1 : 0;
        $input.val(value.toFixed(decimals));
      }
    });
  }

  /**
   * Show error message
   */
  function showError(message, container) {
    clearMessages(container);

    const $error = $('<div class="error">' + message + "</div>");

    $(".calculator-form").prepend($error);
    // Scroll to error
    $("html, body").animate(
      {
        scrollTop: $error.offset().top - 100,
      },
      300
    );
  }

  /**
   * Show success message
   */
  function showSuccess(message, container) {
    clearMessages(container);

    const $success = $('<div class="success">' + message + "</div>");

    $(".calculator-form").prepend($success);
  }

  /**
   * Clear error messages
   */
  function clearErrors(container) {
    $(".calculator-form .error").remove();
    $("input.error").removeClass("error");
  }

  /**
   * Clear all messages
   */
  function clearMessages(container) {
    $(".calculator-form .error, .calculator-form .success").remove();
  }

  /**
   * Utility function to format currency
   */
  function formatCurrency(amount, currency = "USD") {
    const config = dq_aec_ajax.currencies[currency];
    const formatted = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: config.decimal_places,
      maximumFractionDigits: config.decimal_places,
    }).format(amount);

    if (config.position === "before") {
      return config.symbol + formatted;
    } else {
      return formatted + config.symbol;
    }
  }

  /**
   * Analytics tracking (optional)
   */
  function trackCalculatorUsage(data) {
    // This can be extended to integrate with Google Analytics, etc.
    if (typeof gtag !== "undefined") {
      gtag("event", "calculator_used", {
        event_category: "engagement",
        event_label: "efficiency_calculator",
        value: Math.round(data.savings.annual_savings || 0),
      });
    }
  }
})(jQuery);
